import React, { Fragment } from 'react';

import Carousel from 'components/Carousel';
import Contact from 'components/Contact';
import Footer from 'components/Footer';
import Header from 'components/Header';
import Logo from 'components/Logo';

// Webpack imports
// Bootstrap and dependencies
import 'includes/bootstrap';
// Standard styles
import 'styles/reset.css';
import 'styles/bootstrap.css';
// Local styles
import 'styles/gnp.css';
import 'styles/starfield.css';

const Global = () => (
  <Fragment>
    <Header />
    <main role="main">
      <Logo />
      <Carousel />
      <Contact />
    </main>
    <Footer />
  </Fragment>
);

export default Global;



// WEBPACK FOOTER //
// ./src/Global.jsx